import { Box, Typography } from '@mui/material';
import { RouteObject } from 'react-router-dom';

import { ContentContainer } from '@/components';

export const notFoundRoute: RouteObject = {
  path: '*',
  element: (
    <ContentContainer height="100%">
      <Box
        sx={{
          height: `calc(100vh - 48px)`,
          width: `calc(100vw - 50px)`,
          display: 'grid',
          placeItems: 'center',
          bgcolor: '#dee2e6',
          borderRadius: 3,
        }}
      >
        <Typography fontWeight={600} fontSize={24}>
          Not Found
        </Typography>
      </Box>
    </ContentContainer>
  ),
};
